import { useState } from "react";

import { useCall } from "../state/CallProvider";
import { IconBackspace, IconPhone } from "./icons";

const KEYS: [string, string][] = [
  ["1", ""], ["2", "ABC"], ["3", "DEF"],
  ["4", "GHI"], ["5", "JKL"], ["6", "MNO"],
  ["7", "PQRS"], ["8", "TUV"], ["9", "WXYZ"],
  ["*", ""], ["0", "+"], ["#", ""],
];

export function Dialpad() {
  const { dial } = useCall();
  const [num, setNum] = useState("");
  const press = (d: string) => setNum((n) => (n + d).slice(0, 20));
  const call = () => { const n = num.trim(); if (n) void dial({ number: n }); };

  return (
    <div className="dp">
      <div className="dp-display">
        <input className="dp-input" value={num} placeholder="Enter a number"
          onChange={(e) => setNum(e.target.value)} inputMode="tel"
          onKeyDown={(e) => { if (e.key === "Enter") call(); }} />
        {num && <button className="dp-back" onClick={() => setNum((n) => n.slice(0, -1))} aria-label="Backspace"><IconBackspace size={20} /></button>}
      </div>
      <div className="dp-keys">
        {KEYS.map(([d, sub]) => (
          <button key={d} className="dp-key" onClick={() => press(d)}>
            {d}{sub && <small>{sub}</small>}
          </button>
        ))}
      </div>
      <div className="dp-call">
        <button onClick={call} disabled={!num.trim()} aria-label="Call"><IconPhone /></button>
      </div>
    </div>
  );
}
